/**
 * Advantages Section
 *
 * "Why choose our Platform" section with:
 * - Section heading
 * - List of advantages with icons
 * - Illustration on the right
 */

'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/src/shared/ui';
import { Container } from '@/src/shared/ui/Container';
import { Typography } from '@/src/shared/ui/typography/Typography';
import Image from 'next/image';

const advantageKeys = ['easyToUse', 'trustedCommunity', 'directCommunication', 'growReputation'];

export function AdvantagesSection() {
  const t = useTranslations('landing.advantages');
  return (
    <section className="container-auto">
     
        {/* Section Heading */}
        <div className="mb-5">
          <Typography variant="h2" weight="bold" className="text-text-primary">
            {t('title')}
          </Typography>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
          {/* Left Side - Advantages List */}
          <div className="relative space-y-8">
            {/* Vertical line through icons */}
            <div className="absolute left-[15px] top-0 bottom-0 w-[2px] bg-accent-primary" />

            {advantageKeys.map((key) => (
              <div key={key} className="flex gap-4 relative">
                {/* Icon - Plus sign in green circle */}
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-primary flex items-center justify-center z-10">
                  <Icon
                    name='plus'
                    alt="Plus icon"
                    color='inverse'
                  />
                </div>

                {/* Content */}
                <div className="flex-1">
                  <Typography
                    variant="h3"
                    weight="bold"
                    className="text-text-primary mb-2"
                  >
                    {t(`${key}.title`)}
                  </Typography>
                  <Typography variant="body" className="text-text-primary">
                    {t(`${key}.description`)}
                  </Typography>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side - Illustration from SVG file */}
          <div className="relative h-[400px] md:h-[500px] flex items-center justify-center md:justify-end">
            <Image
              src="/images/banners/why_our_platform.svg"
              alt={t('imageAlt')}
              fill
              className="object-contain object-center md:object-right"
              priority
            />
          </div>
        </div>
      
    </section>
  );
}
